import styled from "styled-components";

export const FestivalInterviewBannerWrapper = styled.div`
  width: 100%;
  position: relative;

  > img {
    width: 100%;
    height: 324px;
    object-fit: cover;
    position: relative;
    z-index: 1;
  }

  > .user {
    position: absolute;
    bottom: -26px;
    width: 100%;
    display: flex;
    justify-content: center;
    z-index: 5;

    > img {
      width: 256px;
      height: 269px;
      object-fit: contain;
    }

    > .rank {
      position: absolute;
      bottom: -42px;
      right: 32px;

      > img {
        width: 100px;
        height: 100px;
      }
    }
  }
`;

export const FestivalInterviewBanner = styled.div`
  position: absolute;
  bottom: -26px;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 5;

  > img {
    width: 256px;
    height: 269px;
    object-fit: contain;
  }

  > .rank {
    position: absolute;
    bottom: -42px;
    right: 32px;

    > img {
      width: 100px;
      height: 100px;
    }
  }
`;
